/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
/**
 * Stores the information needed to invoke a function.
 */
export class InvocationHandler {
    /**
     * Instantiates an InvocationDescription.
     * @param fn The Function described by this description object.
     * @param invoker The strategy for invoking the function.
     * @param dependencies The static dependencies of the function call.
     */
    constructor(fn, invoker, dependencies) {
        this.fn = fn;
        this.invoker = invoker;
        this.dependencies = dependencies;
    }
    /**
     * Invokes the function.
     * @param container The calling container.
     * @param dynamicDependencies Additional dependencies to use during invocation.
     * @return The result of the function invocation.
     */
    invoke(container, dynamicDependencies) {
        if (dynamicDependencies !== undefined) {
            return this.invoker.invokeWithDynamicDependencies(container, this.fn, this.dependencies, dynamicDependencies);
        }
        return this.invoker.invoke(container, this.fn, this.dependencies);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW52b2NhdGlvbkhhbmRsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJJbnZvY2F0aW9uSGFuZGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQTs7Ozs7R0FLRztBQUVIOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGlCQUFpQjtJQWdCMUI7Ozs7O09BS0c7SUFDSCxZQUFtQixFQUFZLEVBQUUsT0FBZ0IsRUFBRSxZQUFtQjtRQUNsRSxJQUFJLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQztRQUNiLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO1FBQ3ZCLElBQUksQ0FBQyxZQUFZLEdBQUcsWUFBWSxDQUFDO0lBQ3JDLENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLE1BQU0sQ0FBQyxTQUFvQixFQUFFLG1CQUEyQjtRQUMzRCxJQUFJLG1CQUFtQixLQUFLLFNBQVMsRUFBRTtZQUNuQyxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsNkJBQTZCLENBQzdDLFNBQVMsRUFDVCxJQUFJLENBQUMsRUFBUyxFQUNkLElBQUksQ0FBQyxZQUFZLEVBQ2pCLG1CQUFtQixDQUN0QixDQUFDO1NBQ0w7UUFDRCxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLFNBQVMsRUFBRSxJQUFJLENBQUMsRUFBUyxFQUFFLElBQUksQ0FBQyxZQUFZLENBQUMsQ0FBQztJQUM3RSxDQUFDO0NBQ0oifQ==